import React, { useEffect, useState } from "react";
import {
	Breadcrumb,
	Row,
	Col,
	Card,
	Button,
	BackTop,
	Space,
	Form,
	message,
	InputNumber,
	DatePicker,
	Radio,
} from "antd";
import "../../../styles/admin.css";
import { fetchAdminApi, } from "../../../services/api";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import constants from "../../../constants/constants";
import { useHistory } from "react-router";
import moment from "moment";
const AddEditVersion = (props) => {
	const [isEdit, setIsEdit] = useState(false);
	const [editData, setEditData] = useState(null);
	const storedEditData = sessionStorage.getItem("editVersionData");
	const editFlag = sessionStorage.getItem("isEditVersion");
	const history = useHistory();
	const [form] = Form.useForm();
	const formItemLayout = {
		labelCol: {
			xs: { span: 24, },
			sm: { span: 6, },
			lg: { span: 4, },
		}
	};
	//Validation Checks 
	const handleTaskValidation=(_rule,value,callback)=>{
		try {
			if(value){
				if(value.trim()===""||value.trim()==="<p><br></p>"){
					throw new Error(constants.TaskRequired);
				}
			}else{
				throw new Error(constants.TaskRequired);
			}
			callback();
		} catch (err) {
			callback(err);
		}
	};
	//on Cancel button
	const onCancelBtn=()=>{
		form.resetFields();
		history.push({ pathname: "/version-logs" });
		sessionStorage.removeItem("editVersionData");
		sessionStorage.removeItem("isEditVersion");
	};
	const updateVersion=(values)=>{
		let payload={
			category_id:values.Category,
			type: values.type,
			build_number: values.build_number,
			tasks:values.tasks,
			release_date: values.release_date.format("YYYY-MM-DD"),
		};
		if (isEdit) {
			payload.version_summary_id = editData.version_summary_id;
		}
		fetchAdminApi(`/save-version-summary`, "post", payload).then(
			(res) => {
				if (res && res.code) {
					if (res.code === 200) {
						message.success(res.message);
						history.push({ pathname: "/version-logs" });
						sessionStorage.removeItem("editVersionData");
						sessionStorage.removeItem("isEditVersion");
					} else {
						message.error(res.message);
					}
				} else {
					message.error(constants.AddTaskFailed);
				}
			}
		);
	};
	useEffect(() => {
		if(props && props.history && props.history.location && props.history.location.state){
			form.setFieldsValue({ Category:props.history.location.state.categoryId });
		}
	}, []);
	useEffect(() => {
		if (editFlag === "true" && storedEditData) {
			const parsedData = JSON.parse(storedEditData);
			setIsEdit(true);
			setEditData(parsedData);
			form.setFieldsValue({
				type: parsedData.type,
				build_number: parsedData.build_number,
				tasks: parsedData.tasks,
				release_date: parsedData.release_date
					? moment(parsedData.release_date)
					: moment(),
			});
		}
		else {
			form.setFieldsValue({ release_date: moment() });
		}
	}, []);
	return (
		<div className="div min-h-full">
			<div className="p-3">
				<Breadcrumb>
					<Breadcrumb.Item><a onClick={() => {
						history.push({ pathname: "/admin-dashboard" });
					}}>{constants.Home}</a></Breadcrumb.Item>
					<Breadcrumb.Item>
						<a
							onClick={() => {
								history.push({ pathname: "/masters-menu" });
							}}
						>{constants.Masters}
						</a>
					</Breadcrumb.Item>
					<Breadcrumb.Item><a
						onClick={() => {
							history.push({ pathname: "/version-logs" });
						}}
					>{constants.Version}</a></Breadcrumb.Item>
					{editFlag ? <Breadcrumb.Item>{constants.EditVersionLog}</Breadcrumb.Item> : <Breadcrumb.Item>{constants.AddVersionLog}</Breadcrumb.Item>}
				</Breadcrumb>
			</div>
			<div className="p-4">
				<BackTop/>
				<Row gutter={[24, 24]} >
					<Col xs={24} sm={24} md={24} lg={24}>
						<div className="container mx-auto">
							<Card size="small" title={<span className="text-uppercase">{editFlag ? constants.EditVersionLog : constants.AddVersionLog}</span>} 
							>
								<Form form={form} onFinish={updateVersion} layout="horizontal" {...formItemLayout}>
									<Form.Item
										label="Type"
										name="type"
										rules={[
											{
												required: true,
												message: "Select type",
											},
										]}
									>
										<Radio.Group>
											<Radio value="FE">{constants.Frontend}</Radio>
											<Radio value="BE">{constants.Backend}</Radio>
										</Radio.Group>
									</Form.Item>
									<Form.Item
										label="Build No."
										name="build_number"
										rules={[
											{
												required: true,
												message: "Enter build number",
											},
										]}
									>
										<InputNumber style={{ width: '100%' }}/>
									</Form.Item>
									<Form.Item
										label="Task"
										name="tasks"
										rules={[
											{
												required: true,
												message: "",
											},
											{ validator: handleTaskValidation },
										]}
										initialValue=''
									>
										<ReactQuill theme="snow"  modules={constants.ReactQuillModules} formats={constants.ReactQuillFormats}/>
									</Form.Item>
									<Form.Item
										label="Release Date"
										name="release_date"
										rules={[
											{
												required: true,
												message: "Select release date",
											},
										]}
									>
										<DatePicker format={constants.dateFormat}/>
									</Form.Item>
									<div className="text-right">
										<Space>
											<Form.Item>
												<Button type="primary" htmlType="submit" className="navy-btn" >{constants.Save}</Button>
											</Form.Item>
											<Form.Item>
												<Button onClick={onCancelBtn}>{constants.CancelBTN}</Button>
											</Form.Item>
										</Space>
									</div>
								</Form>
							</Card>
						</div>
					</Col>
				</Row> 
			</div>
		</div>
	);
};
export default AddEditVersion;
